<!--
  - Copyright Huesik (c) 2019.
  - 화면에서 보여주는 해쉬태그 컴포넌트 입니다.
  - 나중에 속성값이 추가되서 해쉬태그 추가해야한다면 이쪽에서 작업해주세요.
  -->

<template>
  <p class="hash-tag-list">
    <span v-if="options.use_sex_type === 'M'">#남성전용</span>
    <span v-if="options.use_sex_type === 'W'">#여성전용</span>
    <span v-if="options.use_sex_type === 'U'">#남녀공용</span>
    <span v-if="options.use_sex_type === 'S'">#남녀층분리</span>
    <span v-if="options.room_type && options.room_type.indexOf('M') >= 0">#미니룸</span>
    <span v-if="options.room_type && options.room_type.indexOf('O') >= 0">#원룸</span>
    <span v-if="options.room_type && options.room_type.indexOf('S') >= 0">#샤워룸</span>
    <span v-if="options.option_aircon">#개별에어컨</span>
    <span v-if="options.is_elevator">#엘리베이터</span>
    <span v-if="options.is_parking">#주차가능</span>
    <span v-if="options.option_doorlock">#도어락</span>
    <!--<span v-if="options.use_sex_type === 'M'">남성전용</span>-->
  </p>
</template>

<script>
  export default {
    name: 'hashTagList',
    props: {
      options: {
        type: Object,
        default: () => {}
      }
    },
    mounted () {
      // console.log(this.options.room_type.indexOf('O'))
    }
  }
</script>

<style scoped>
  p {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
    /*display: inline-block;*/
    /*vertical-align: middle;*/
  }
</style>
<style scoped lang="less" >
  @import "../../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {
    p {
      display: block;
    }
  }
</style>
